import { usePrintHousePrinters } from "@/hooks/use-print-house-printers";

/** @deprecated Use usePrintHousePrinters — kept for backward compatibility. */
const usePrintNodePrinters = () => usePrintHousePrinters();

export { usePrintNodePrinters };
